import React,{useEffect, useMemo,useState, useTransition} from 'react'
import { useLoaderData,useNavigate} from 'react-router-dom';
import ColonyCard from '../../../components/colonycard/ColonyCard';
import "./MasterColonyList.scss"
import encryptedapiRequest from '../../../lib/encryptedapiRequest';
import ContainerLoader from '../../../components/spinner/ContainerLoader';


function MasterColonyList() {

    // const {toggleMenu} = useOutletContext(); // get the toggleMenu function
    const [masterColonies,setMasterColonies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    // const [isPending, startTransition] = useTransition();


  const fetchDatafromServer = async () => {
    try {
      // setLoading(true);
      const response = await encryptedapiRequest.get(`/masters/colonieslocation`);
      // setLoading(false);
      return response.data;
    } catch (error) {
      console.error("Fetching pending data failed:", error);
      // setLoading(false);
      throw error;
    }
  };



    const LoadData= async()=>{
      try {
        setLoading(true);
        const data=await fetchDatafromServer();
        // console.log("fetched from server",data)
        setMasterColonies(data);
        // setTimeout(() => {
        //   setMasterColonies(data);
        // }, 2000);

        // startTransition(() => {
        //   setMasterColonies(data);
        // });

      } catch (error) {
        setError(error)
        console.error("Error fetcing Master Colonies:", error);        
      } finally{
        setLoading(false);
      }
    }
  
  useEffect(() => {
  
    LoadData();
  
  }, []);
  
  



    const [searchQuery, setSearchQuery] = useState("");    
    // const [masterColonies, setMasterColonies] = useState([]);
    // const masterColonies = useLoaderData()?.MasterColonyLocationResponse||[];







    // console.log("MasterColonies",masterColonies)
    const navigate=useNavigate()    
    // 🔎 Filter colonies when searchQuery changes
    const filteredColonies = useMemo(() => {
        if (!searchQuery.trim()) return masterColonies;

        const lower = searchQuery.toLowerCase();

        return masterColonies.filter(colony =>
            colony.colonyname?.toLowerCase().includes(lower)
        );
    }, [masterColonies, searchQuery]);






const handleNewColony = async (e) => {
  e.preventDefault(); // 👈 prevent the NavLink from navigating
  // alert("ss")


  try {
         navigate('/admin/colony/0', {
            state: { mode: 0, colonyid: 0 }
        });    

  } catch (error) {
    console.log(error);
  }
};




  return (
    <>
    <div className="colonyListPage">
        {/* <div className="PageHeader">

          <DashboardHeader title="Master Colony List" toggleMenu={toggleMenu} variant="admin"></DashboardHeader>

        </div> */}


        <div>
          <button onClick={(e)=>handleNewColony(e)}>Add Colony</button>
        </div>

        <div className="searchrow" >
            {/* 🔎 Search input */}
            <div style={{ marginBottom: "1rem" }}>
                <input
                    type="text"
                    placeholder="Search colonies..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ padding: "8px", width: "100%", maxWidth: "400px" }}
                />
            </div>
        </div>

        <div className="colonyListContainer">
           {(loading ) && <ContainerLoader />}

          {!loading &&
            filteredColonies.map(colony => (
              <ColonyCard key={colony.id} item={colony} />
            ))
          }                

        </div>

          {/* <CancelButton></CancelButton> */}
    </div>
    </>
  )
}

export default MasterColonyList